import { render, staticRenderFns } from "./wlList.vue?vue&type=template&id=1b1d2621&scoped=true&"
import script from "./wlList.vue?vue&type=script&lang=js&"
export * from "./wlList.vue?vue&type=script&lang=js&"
import style0 from "./wlList.vue?vue&type=style&index=0&id=1b1d2621&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1d2621",
  null
  
)

export default component.exports